export const dataAutologs = {
  mindmap: {
    feature: 'button',
    exp: true,
    key: 'tingwu_exp_mindmap_tab_click',
    text: '思维导图',
  },
  keywordExpand:
    'feature=button&exp=true&key=tingwu_exp_keyword_expand_click&text=展开全部',
  summarization:
    'feature=button&exp=true&key=tingwu_exp_summarization_click&text=全文摘要',
  agenda: 'feature=button&exp=true&key=tingwu_exp_agenda_click&text=章节速览',
  speakerSummary:
    'feature=button&exp=true&key=tingwu_exp_speaker_summary_click&text=发言总结',
  questions:
    'feature=button&exp=true&key=tingwu_exp_questions_click&text=要点回顾',
  todoList:
    'feature=button&exp=true&key=tingwu_exp_todo_list_click&text=待办事项',
  ppt: 'feature=button&exp=true&key=tingwu_exp_ppt_click&text=提取PPT',
};
